import { render, staticRenderFns } from "./UnitOfMeasures.vue?vue&type=template&id=2cacfe55"
import script from "./UnitOfMeasures.vue?vue&type=script&lang=ts"
export * from "./UnitOfMeasures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports